import React from 'react';
import { 
  FaFacebook, 
  FaInstagram, 
  FaLinkedin, 
  FaTwitter, 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaHeart,
  FaStethoscope,
  FaUserMd,
  FaHome,
  FaFileAlt,
  FaShieldAlt,
  FaYoutube,
  FaWhatsapp
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const socialLinks = [
    {
      icon: <FaFacebook />,
      href: 'https://www.facebook.com/people/Dr-Shailendra-Mohan-Shukla/61577993564809/',
      label: 'Facebook',
      color: 'hover:bg-blue-600'
    },
    {
      icon: <FaInstagram />,
      href: 'https://www.instagram.com/p/DQY0PvmAd7U/',
      label: 'Instagram',
      color: 'hover:bg-pink-600'
    },
    {
      icon: <FaLinkedin />,
      href: '#',
      label: 'LinkedIn',
      color: 'hover:bg-blue-700'
    },
    {
      icon: <FaTwitter />,
      href: '#',
      label: 'Twitter',
      color: 'hover:bg-black'
    },
    {
      icon: <FaYoutube />,
      href: '#',
      label: 'YouTube',
      color: 'hover:bg-red-600'
    }
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-10 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 pb-8 border-b border-gray-800">
          
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <FaUserMd className="text-blue-400 text-xl" />
              <h3 className="text-lg font-bold text-blue-400">About Us</h3>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Dr. Shailendra Mohan Shukla is one of the most trusted and renowned Urologists in Ranchi, dedicated to delivering advanced and compassionate urological care. With years of experience and expertise in diagnosing and treating a wide range of urological conditions.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold text-blue-400 mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-300 hover:text-blue-400 text-sm transition-colors duration-300 flex items-center">
                  <FaHome className="mr-2 text-xs" />
                  Home
                </a>
              </li>
              <li>
                <a href="/about-doctor" className="text-gray-300 hover:text-blue-400 text-sm transition-colors duration-300 flex items-center">
                  <FaUserMd className="mr-2 text-xs" />
                  Dr. Shailendra Mohan Shukla
                </a>
              </li>
              <li>
                <a href="/blog" className="text-gray-300 hover:text-blue-400 text-sm transition-colors duration-300 flex items-center">
                  <FaFileAlt className="mr-2 text-xs" />
                  Blog
                </a>
              </li>
              
              <li className="pt-2">
                <a href="/contact" className="text-gray-300 hover:text-blue-400 text-sm transition-colors duration-300 flex items-center">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-blue-400 mb-4">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center mr-3 flex-shrink-0">
                  <FaPhone className="text-blue-400" />
                </div>
                <div>
                  <a href="tel:+918002280222" className="text-gray-300 hover:text-blue-400 text-sm transition-colors duration-300 block">
                    +91 8002280222
                  </a>
                  <span className="text-gray-500 text-xs">24/7 Emergency Available</span>
                </div>
              </li>
              <li className="flex items-start">
                <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center mr-3 flex-shrink-0">
                  <FaEnvelope className="text-blue-400" />
                </div>
                <div>
                  <a href="mailto:aarogyavijayofficial@gmail.com" className="text-gray-300 hover:text-blue-400 text-sm transition-colors duration-300 block">
                   aarogyavijayofficial@gmail.com
                  </a>
                  <span className="text-gray-500 text-xs">Response within 24 hours</span>
                </div>
              </li>
              <li className="flex items-start">
                <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center mr-3 flex-shrink-0">
                  <FaMapMarkerAlt className="text-blue-400" />
                </div>
                <div>
                  <span className="text-gray-300 text-sm">
                     City Clinic, 1st Floor, RIMS Medical Chowk, Opposite Jharkhand Eye Bank Hospital, Bariatu, Ranchi, PIN- 834009, Ranchi, Jharkhand 834009
                  </span>
                  <span className="text-gray-500 text-xs block">Get Directions</span>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-blue-400 mb-4">Follow Us</h3>
            <div className="mb-6">
              <p className="text-gray-400 text-sm mb-4">Connect with us on social media</p>
              <div className="flex flex-wrap gap-3">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-12 h-12 rounded-full bg-gray-800 ${social.color} flex items-center justify-center transition-all duration-300 transform hover:scale-110`}
                    aria-label={social.label}
                  >
                    <span className="text-white text-lg">{social.icon}</span>
                  </a>
                ))}
              </div>
            </div> 
            <div className="pt-4 border-t border-gray-800">
              <div className="flex items-center text-gray-400 text-sm">
                <FaHeart className="text-red-500 mr-2 animate-pulse" />
                <span>Compassionate Care, Advanced Treatment</span>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-6 text-center">
          <div className="text-gray-400 text-sm mb-2">
            Copyrights © {currentYear} City Clinic. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;